import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import AddIcon from '@mui/icons-material/Add';
import {Box} from '@mui/material';

import {EmpionButton} from '../../../../components/EmpionButton/EmpionButton';
import {ModulePageHeader} from '../../../../components/ModulePageHeader/ModulePageHeader';
import {CompanyWorkforceProfilesTable} from '../../../../features/company/workforce/components/WorkforceProfiles/CompanyWorkforceProfilesTable';

export const WorkforceProfilesPage = () => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage'});
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <Box sx={{maxWidth: 1120, mx: 'auto', width: '100%'}}>
      <ModulePageHeader
        moduleName={t('breadcrumb')}
        title={t('title')}
        actions={
          <EmpionButton variant='primary' startIcon={<AddIcon />} onClick={() => setIsCreateModalOpen(true)}>
            {t('newProfile')}
          </EmpionButton>
        }
      />

      <CompanyWorkforceProfilesTable
        createModalOpen={isCreateModalOpen}
        onCreateModalClose={() => setIsCreateModalOpen(false)}
      />
    </Box>
  );
};
